(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-stellar"]) return;
  try {
    
(function () {
  var root = document.querySelector('.sth');
  if (!root) return;

  if (root.classList.contains('sth--sticky')) {
    /* ---------------------------------------------------------------
       A FAIXA DE AVISOS RECOLHE ENQUANTO A PESSOA DESCE A PAGINA.

       A barra fica. Quem sai e so a faixa — e ela ja sabe fazer isso: e o
       mesmo `is-av` que a faz descer no carregamento, agora tirado e posto
       de volta. Zero CSS novo, zero risco pro cabecalho.

       "Parou" nao existe como evento: o navegador so avisa que rolou. Entao
       a parada e inferida — cada rolagem reagenda um despertador, e ele so
       chega a tocar quando nenhuma rolagem nova o adiou. No iOS a inercia
       continua disparando eventos depois do dedo sair, o que joga a favor:
       a faixa so volta quando a pagina assentou.

       Qualquer movimento recolhe — descer e subir. Antes, subir devolvia a
       faixa na hora, partindo da ideia de que quem sobe esta voltando pro
       topo; na pratica quase toda leitura sobe um pouco (reler um trecho,
       corrigir um exagero do dedo) e a faixa piscava no meio do texto. Agora
       ela so volta em duas situacoes: a pessoa parou, ou chegou no topo.
    ---------------------------------------------------------------- */
    var recolheLigado = root.getAttribute('data-fuga') !== 'nao';
    var temFaixa = !!root.querySelector('[data-sth-aviso]');
    /* quanto tempo de silencio conta como "parou". Era fixo em 260ms, o que
       trazia a faixa de volta quase junto com o dedo: bastava hesitar entre
       dois impulsos de rolagem pra ela reaparecer no meio da leitura. Agora
       o valor vem do ajuste da secao — e o padrao e mais generoso. */
    var ESPERA = parseInt(root.getAttribute('data-av-volta'), 10);
    if (!(ESPERA >= 0)) ESPERA = 5000;
    var GATILHO = 10;     /* pixels que contam como "mexeu" */
    var PISO = 60;        /* antes disso a faixa e cabecalho, e fica */

    var ultimoY = window.scrollY;
    var relogioFaixa = null;
    /* Travar e destravar a rolagem (abrir e fechar o menu) mexe no scrollY
       de proposito, e o navegador anuncia isso como rolagem — e o tema ainda
       devolve a posicao com rolagem suave, que dispara eventos por uns
       250ms. Sem esta janela surda a faixa sumia sozinha ao fechar o menu. */
    var surdoAte = 0;

    function mostraFaixa() { if (temFaixa) root.classList.add('is-av'); }
    function recolheFaixa() { if (temFaixa) root.classList.remove('is-av'); }

    var onScroll = function () {
      var yAtual = window.scrollY;
      root.classList.toggle('is-scrolled', yAtual > 12);

      if (!recolheLigado || !temFaixa) return;
      if (Date.now() < surdoAte) { ultimoY = yAtual; return; }

      var d = yAtual - ultimoY;

      /* no topo a faixa fica, sem esperar a pessoa parar */
      if (yAtual <= PISO) {
        clearTimeout(relogioFaixa);
        mostraFaixa();
        ultimoY = yAtual;
        return;
      }

      /* SO MOVIMENTO DE VERDADE CONTA — e este return e a trava mais
         importante daqui. O despertador da volta so pode ser adiado por
         rolagem real; se qualquer outra coisa na pagina disparar evento de
         scroll sem a posicao mudar (app de terceiro, animacao presa ao
         scroll, imagem que carrega e empurra o layout), adiar por isso
         deixaria a faixa recolhida pra sempre. */
      if (Math.abs(d) < GATILHO) return;
      ultimoY = yAtual;

      /* descendo ou subindo, o gesto recolhe do mesmo jeito. Quem devolve
         a faixa e o despertador logo abaixo (parou) ou o piso (topo). */
      recolheFaixa();

      clearTimeout(relogioFaixa);
      /* NO CELULAR ELA SO VOLTA NO TOPO — Raio-X G1-8, 30/09. Com a faixa
         voltando a cada pausa, a pilula media 112px (13% da tela) durante
         quase toda a leitura e cobria o topo das secoes. No celular, depois
         do piso, a faixa fica recolhida ate a pessoa voltar ao topo (o
         `yAtual <= PISO` acima). No computador continua voltando na pausa. */
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return;
      relogioFaixa = setTimeout(function () {
        mostraFaixa();
        ultimoY = window.scrollY;
      }, ESPERA);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    /* abrir o menu recolhe a faixa (o painel sai da mesma borda); fechar
       devolve. Nos dois casos a janela surda cobre o pulo da rolagem. */
    root.addEventListener('sth:abriu', function () {
      clearTimeout(relogioFaixa);
      surdoAte = Date.now() + 700;
    });
    root.addEventListener('sth:fechou', function () {
      clearTimeout(relogioFaixa);
      mostraFaixa();
      surdoAte = Date.now() + 700;
      /* ler scrollY logo depois de destravar forcava layout dentro do toque (INP); um quadro depois sai de graca */
      requestAnimationFrame(function () { ultimoY = window.scrollY; });
    });
  }

  /* ==================================================================
     ABRIR E FECHAR
     Um estado so: is-menu OU is-sacola, nunca os dois. Abrir um fecha o outro
     sem destravar a rolagem no meio do caminho — destravar e travar de novo
     faz a pagina pular.
     ================================================================== */
  /* O BICO APONTA PRA SACOLA, MEDINDO ELA.
     Ver o comentario no CSS: os icones encolhem por flex, entao a distancia
     nao pode ser um numero escrito. Roda no carregamento e a cada mudanca de
     largura; se algo faltar, o CSS cai no valor de reserva. */
  function sthPosBico() {
    var alvo = root.querySelector('[data-sth-sacola]');
    var pil  = root.querySelector('.sth__in');
    var bic  = root.querySelector('.sth-bico');
    if (!alvo || !pil || !bic) return;
    var ra = alvo.getBoundingClientRect(), rp = pil.getBoundingClientRect();
    if (!ra.width || !rp.width) return;
    /* `inset-inline-end` conta da borda INTERNA do bloco de contencao, e o
       retangulo medido vai ate a externa. Sem descontar a borda da pilula o
       bico assentava 1px a esquerda do centro da sacola — medido. */
    var bd = parseFloat(getComputedStyle(pil).borderRightWidth) || 0;
    var x = rp.right - bd - (ra.left + ra.width / 2) - (bic.offsetWidth || 16) / 2;
    pil.style.setProperty('--sth-bico-x', x.toFixed(1) + 'px');
  }
  sthPosBico();
  /* G2-3 (correcoes F1): no resize a medida vai pra um quadro de animacao,
     uma vez por quadro — o resize dispara em rajada e cada chamada lia o
     layout na hora. */
  var bicoPedido = false;
  window.addEventListener('resize', function () {
    if (bicoPedido) return; bicoPedido = true;
    requestAnimationFrame(function () { bicoPedido = false; sthPosBico(); });
  }, { passive: true });

  /* ================================================================
     "COMPARE OS MODELOS" ABRE O COMPARATIVO, NAO SO ROLA ATE ELE.

     O link levava pra `#escolha-seu-stellar`, que e a vitrine dos dois
     modelos na home. Só que a comparacao de verdade — a folha "Lado a
     lado, medida por medida" — mora atras de um botao dentro dessa secao.
     Quem clicava chegava na porta e tinha que abrir a porta de novo.

     Agora o link aponta pra `#comparar` e este bloco cuida do resto:
     rola ate a secao e aciona o `[data-sti]`, que e o mesmo gatilho do
     "Comparar todos os modelos" da propria home. Nao ha duplicacao de
     comportamento — so o disparo remoto do que ja existe.

     Dois caminhos, porque sao duas situacoes diferentes:

     · vindo de OUTRA pagina, o navegador carrega a home com o hash e o
       `hashchange` nunca dispara. Dai a chamada no carregamento.

     · ja na home, o menu esta aberto por cima. Ai o clique e interceptado:
       fecha o painel, deixa a animacao respirar e so entao abre a folha —
       abrir as duas coisas no mesmo quadro deixava a folha atras do menu.

     A espera por tentativas existe porque a secao da home e hidratada
     depois do HTML: no primeiro quadro o botao ainda nao existe. 40 x
     120ms cobre ~5s e desiste em silencio se a home mudar de desenho. */
  function sthComparativo() {
    var tenta = 0;
    (function espera() {
      var bt = document.querySelector('[data-sti]');
      if (bt) {
        var sec = document.getElementById('escolha-seu-stellar');
        if (sec) sec.scrollIntoView({ block: 'start', behavior: 'auto' });
        bt.click();
        return;
      }
      if (++tenta < 40) setTimeout(espera, 120);
    })();
  }
  function sthSeForComparar() {
    if ((location.hash || '').toLowerCase() === '#comparar') sthComparativo();
  }
  sthSeForComparar();
  window.addEventListener('hashchange', sthSeForComparar);

  root.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('.sth-cmp, .sth-nav__link');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.toLowerCase().indexOf('#comparar') === -1) return;
    /* so intercepta se o destino for ESTA pagina; senao deixa navegar.
       09/10: "/" virava "" ao tirar a barra final e passava por "mesma
       pagina" em QUALQUER pagina: o clique era engolido e, fora da home,
       nada abria. Agora "" so vale para link que e so o hash. */
    var semBarra = function (p) { return p.replace(/\/$/, '') || '/'; };
    var la = href.split('#')[0];
    if (la !== '' && semBarra(la) !== semBarra(location.pathname)) return;
    ev.preventDefault();
    fechar(false);
    setTimeout(sthComparativo, 260);
  });

  /* ================================================================
     O "COMPRE JA" NA PROPRIA PAGINA — Raio-X G2-9, 30/09.

     O Liquid ja escreveu o destino certo pra cada pagina (ver o comentario
     no HTML do botao). Aqui ficam as duas coisas que so o navegador sabe:

     1. Se a ancora existe mesmo. Um modelo de produto sem o bloco #comprar
        teria um botao morto; nesse caso ele volta a ser o link e o rotulo do
        editor, que e o comportamento antigo.
     2. Rolar descontando a barra fixa e, no bloco de compra, levar o foco
        pra voltagem — que e a pergunta que falta responder antes do
        "Adicionar". Sem voltagem na pagina (a escova), o foco vai pro
        proprio bloco, pro leitor de tela anunciar onde a pessoa chegou.

     O carrinho com produto nao passa por aqui: la o link e o /checkout
     puro, sem script no meio do caminho do pagamento. */
  (function () {
    var cta = root.querySelector('[data-sth-cta]');
    if (!cta) return;

    /* G2-22 · header_compre_ja_click (correcoes F1 · 01/10).
       Um evento no dataLayer a cada toque no "Compre ja", com a pagina de
       onde ele saiu (so o caminho, sem ?query) e o modo do botao (compra,
       vitrine...). Leva `stl_n`, o mesmo contador dos eventos da PDP
       (stellar-pro.js): o Wascer descarta push com JSON repetido, e sem o
       numero o segundo toque na mesma pagina sumiria. O contador e um so por
       pagina (window.__stlSeq), entao a ordem entre cabecalho e PDP e real.
       Ouvido na fase de captura e passivo: roda antes do clique abaixo, que
       pode trocar de pagina, e nunca segura o toque. O push vai na hora
       (um link para outra pagina mataria um push adiado). */
    cta.addEventListener('click', function () {
      try {
        var n = window.__stlSeq = (window.__stlSeq || 0) + 1;
        (window.dataLayer = window.dataLayer || []).push({
          event: 'header_compre_ja_click',
          pagina: location.pathname,
          modo: cta.getAttribute('data-sth-cta') || '',
          stl_n: n
        });
      } catch (_) {}
    }, { capture: true, passive: true });

    function alvoDoCta() {
      var h = cta.getAttribute('href') || '';
      if (h.charAt(0) !== '#' || h.length < 2) return null;
      try { return document.getElementById(decodeURIComponent(h.slice(1))); } catch (e) { return null; }
    }
    function conferir() {
      var h = cta.getAttribute('href') || '';
      if (h.charAt(0) !== '#') return;
      if (alvoDoCta()) return;
      var reserva = cta.getAttribute('data-sth-cta-reserva');
      var rotulo = cta.getAttribute('data-sth-cta-rotulo');
      if (reserva) cta.setAttribute('href', reserva);
      if (rotulo) cta.textContent = rotulo;
      cta.setAttribute('data-sth-cta', 'vitrine');
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', conferir);
    else conferir();

    cta.addEventListener('click', function (e) {
      var alvo = alvoDoCta();
      if (!alvo) return;
      e.preventDefault();
      fechar(false);
      var compra = cta.getAttribute('data-sth-cta') === 'compra';
      var volt = compra ? alvo.querySelector('#volt [aria-pressed="true"]:not([disabled]), #volt [aria-checked="true"]:not([disabled]), #volt button:not([disabled])') : null;
      var pil = root.querySelector('.sth__in');
      var folga = pil ? Math.max(0, pil.getBoundingClientRect().bottom) + 12 : 80;
      var y = alvo.getBoundingClientRect().top + window.scrollY - folga;
      /* No celular o bloco de compra comeca pela galeria: rolar ate o topo
         dele deixava a voltagem fora da tela. Com voltagem na pagina, quem
         vai pro meio da tela e a pergunta, com o preco logo acima dela. */
      var grupoVolt = volt && (volt.closest('.cpr-volt') || volt.closest('#volt'));
      if (grupoVolt) y = grupoVolt.getBoundingClientRect().top + window.scrollY - Math.round(window.innerHeight * 0.4);
      var calmo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { window.scrollTo({ top: Math.max(0, y), behavior: calmo ? 'auto' : 'smooth' }); }
      catch (err) { window.scrollTo(0, Math.max(0, y)); }
      if (!compra) return;
      var foco = volt || alvo;
      if (!volt && !alvo.hasAttribute('tabindex')) alvo.setAttribute('tabindex', '-1');
      setTimeout(function () { try { foco.focus({ preventScroll: true }); } catch (err) {} }, calmo ? 0 : 450);
    });
  })();

  var btnMenu = root.querySelector('[data-sth-menu]');
  var btnSac  = root.querySelector('[data-sth-sacola]');
  var painel  = root.querySelector('[data-sth-sac]');
  var veu     = root.querySelector('[data-sth-veu]');
  var conta   = root.querySelector('[data-sth-conta]');
  var y = 0;

  /* Trava leve: overflow:hidden no html nao mexe no layout nem na posicao de rolagem, entao nao ha o que
     restaurar ao fechar (era o void scrollTop + scrollTo + scrollBehavior que custava 250-500 ms no celular).
     iOS < 16 ignora overflow no html: ali fica o caminho antigo (body fixed). */
  var TRAVA_LEVE = !!(window.CSS && CSS.supports && CSS.supports('overscroll-behavior', 'none'));
  function travar() {
    y = window.scrollY;
    document.body.classList.add('sth-travado');
    if (TRAVA_LEVE) { document.documentElement.classList.add('stl-trava-menu'); return; }
    document.body.style.top = -y + 'px';
    document.body.style.position = 'fixed';
    document.body.style.insetInline = '0';
  }
  /* POR QUE A PAGINA DESLIZAVA AO FECHAR O MENU.

     Travar poe o body em position:fixed. Nesse instante o documento perde a
     altura e a rolagem vai pra 0 — por isso o topo guarda o y antes. Destravar
     devolve o body e manda a pagina de volta pro y guardado.

     So que a folha global tem html{scroll-behavior:smooth}, que existe pras
     ancoras do menu nao pularem seco. Essa regra vale pra QUALQUER rolagem
     programatica, inclusive esta: em vez de devolver a posicao, o navegador
     animava de 0 ate o y. Medido, eram ~720ms de pagina inteira deslizando
     na cara de quem so fechou o menu.

     A correcao desliga a curva nos dois lugares que decidem isso: o inline
     no html vence a folha, e o behavior:'instant' cobre o caso de o inline
     ainda nao ter sido aplicado. A leitura de scrollTop no meio forca o
     recalculo antes do salto. Depois o inline sai e as ancoras voltam a
     deslizar como antes.
     10/2026: isto agora so vale para o caminho antigo (sem TRAVA_LEVE). */
  function destravar() {
    document.body.classList.remove('sth-travado');
    if (TRAVA_LEVE) { document.documentElement.classList.remove('stl-trava-menu'); return; }
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.insetInline = '';
    /* 'instant' ja vence o html{scroll-behavior:smooth}; o inline no html so no navegador sem 'instant' */
    try { window.scrollTo({ top: y, left: 0, behavior: 'instant' }); }
    catch (e) {
      var raiz = document.documentElement, antes = raiz.style.scrollBehavior;
      raiz.style.scrollBehavior = 'auto'; window.scrollTo(0, y); raiz.style.scrollBehavior = antes;
    }
  }
  function aberto() { return root.classList.contains('is-menu') || root.classList.contains('is-sacola'); }

  /* INERT ACOMPANHA O ESTADO — Raio-X G1-12, 30/09.
     O HTML nasce com os dois fechados e `inert`; aqui so se espelha o estado.
     A sacola so e tocada enquanto mora no cabecalho: na pagina /cart ela e
     levada para o conteudo e vira regiao comum, que nunca pode ficar inerte. */
  var gaveta = root.querySelector('#sthGav');
  function sacNoCabecalho() { return !!(painel && root.contains(painel)); }
  function marcarInerte(qual) {
    if (gaveta) gaveta.inert = qual !== 'is-menu';
    if (sacNoCabecalho()) painel.inert = qual !== 'is-sacola';
  }

  /* G2-3 · A GAVETA FECHA POR RECORTE (correcoes F1 · 01/10).
     Ver o CSS "A GAVETA ABRE POR RECORTE". Aqui so as classes de passagem:
     ao fechar, a gaveta fica montada (is-menu-saindo) enquanto o recorte da
     pilula volta a capsula, e recolhe de vez quando ele termina. Trocando
     direto pra sacola nao ha passagem: o painel da sacola mora dentro da
     pilula e seria recortado junto. Nenhuma leitura de layout aqui. */
  var saindoRelogio = null;
  function menuSaindo(comAnimacao) {
    clearTimeout(saindoRelogio);
    if (!comAnimacao) { root.classList.remove('is-menu-saindo'); return; }
    root.classList.add('is-menu-saindo');
    saindoRelogio = setTimeout(function () { root.classList.remove('is-menu-saindo'); }, 360);
  }

  function fechar(devolveFoco) {
    if (!aberto()) return;
    var eraMenu = root.classList.contains('is-menu');
    root.classList.remove('is-menu', 'is-sacola', 'is-aberto', 'is-menu-entrando');
    if (eraMenu) menuSaindo(true);
    if (btnMenu) btnMenu.setAttribute('aria-expanded', 'false');
    if (btnSac) btnSac.setAttribute('aria-expanded', 'false');
    marcarInerte('');
    destravar();
    root.dispatchEvent(new CustomEvent('sth:fechou'));
    if (devolveFoco !== false) {
      var alvo = eraMenu ? btnMenu : btnSac;
      if (alvo) alvo.focus({ preventScroll: true });
    }
  }
  function abrir(qual) {
    if (!aberto()) travar();
    var eraMenu = root.classList.contains('is-menu');
    var voltando = root.classList.contains('is-menu-saindo');
    menuSaindo(false);
    root.classList.remove('is-menu', 'is-sacola', 'is-menu-entrando');
    /* menu do zero: o primeiro quadro nasce com o recorte fechado e so no
       seguinte o recorte abre. Se ele ainda estava fechando, abre dali. */
    if (qual === 'is-menu' && !eraMenu && !voltando) {
      root.classList.add('is-menu-entrando');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { root.classList.remove('is-menu-entrando'); });
      });
    }
    root.classList.add(qual, 'is-aberto');
    if (btnMenu) btnMenu.setAttribute('aria-expanded', String(qual === 'is-menu'));
    if (btnSac) btnSac.setAttribute('aria-expanded', String(qual === 'is-sacola'));
    marcarInerte(qual);
    /* A SACOLA E UM DIALOGO: o foco entra nela. Antes ele ficava no icone,
       atras do painel, e o Tab andava pela pagina de baixo. Vai pro "fechar",
       que existe cheia ou vazia; a armadilha do Tab fica mais abaixo. */
    if (qual === 'is-sacola' && sacNoCabecalho()) {
      var x = painel.querySelector('.sth-sac__x');
      if (x) requestAnimationFrame(function () { try { x.focus({ preventScroll: true }); } catch (e) {} });
    }
    /* se a barra estava recolhida pela rolagem, volta na hora */
    root.dispatchEvent(new CustomEvent('sth:abriu'));
    /* O RODAPE SO TEM ALTURA DE VERDADE DEPOIS DE ABRIR.

       Fechado ele mede 169px; aberto, 184. Medi os dois. O ResizeObserver
       deveria pegar essa mudanca e nao pegou de forma confiavel, entao a
       medicao acontece onde o fato acontece: no ato de abrir, num quadro
       depois (pro layout assentar) e ao fim da transicao do painel. Tres
       tentativas baratas valem mais que um observador que as vezes dorme. */
    if (typeof medirRodape === 'function') {
      requestAnimationFrame(function () { requestAnimationFrame(medirRodape); });
      setTimeout(medirRodape, 260);
      setTimeout(medirRodape, 700);
    }
  }

  if (btnMenu) {
    btnMenu.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      root.classList.contains('is-menu') ? fechar() : abrir('is-menu');
    });
  }
  if (btnSac) {
    btnSac.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      root.classList.contains('is-sacola') ? fechar() : abrir('is-sacola');
    });
  }
  if (veu) veu.addEventListener('click', function () { fechar(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechar(); });

  /* O TAB NAO SAI DA SACOLA ABERTA — Raio-X G1-12, 30/09.
     Ela e `aria-modal`: com ela aberta, a pagina de baixo nao existe pro
     teclado. Do ultimo controle o Tab volta pro primeiro, e o Shift+Tab faz
     o caminho inverso. Foco fora do painel (no icone, por exemplo) entra
     pelo primeiro. Esc continua fechando e devolvendo o foco ao icone. */
  function focaveis(caixa) {
    var sel = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(caixa.querySelectorAll(sel), function (el) {
      return !el.closest('[hidden], [inert]') && el.getClientRects().length > 0;
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !root.classList.contains('is-sacola') || !sacNoCabecalho()) return;
    var lista = focaveis(painel);
    if (!lista.length) return;
    var primeiro = lista[0], ultimo = lista[lista.length - 1];
    var dentro = painel.contains(document.activeElement);
    if (!dentro) { e.preventDefault(); (e.shiftKey ? ultimo : primeiro).focus(); return; }
    if (e.shiftKey && document.activeElement === primeiro) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primeiro.focus(); }
  });

  /* toque fora fecha o menu. O clique nasce dentro da pilula quando a gaveta
     esta aberta, entao o teste e por conteudo, nao por alvo exato. */
  document.addEventListener('click', function (e) {
    if (!aberto()) return;
    var dentro = root.querySelector('.sth__in').contains(e.target) ||
                 (painel && painel.contains(e.target));
    if (!dentro) fechar(false);
  });
  root.querySelectorAll('.sth-drop__it').forEach(function (a) {
    a.addEventListener('click', function () { fechar(false); });
  });

  /* ==================================================================
     A SACOLA
     Quem manda no preco e o Liquid: depois de mexer na quantidade eu peco o
     snippet de volta pela API de renderizacao de secao em vez de recalcular
     dinheiro no navegador. Assim moeda, impostos, descontos automaticos e
     regra de frete continuam saindo do servidor.
     ================================================================== */
  /* vem do atributo no .sth, escrito pelo Liquid. Sem ele a rota volta 404
     e o painel fica congelado no estado antigo, sem erro nenhum no console —
     fetch nao rejeita em 404, so entrega um corpo vazio. */
  var SECAO = (root && root.getAttribute('data-sth-secao')) || '';

  /* O FOCO SOBREVIVE A REPINTURA — Raio-X G1-12, 30/09.
     Repintar troca o HTML inteiro do painel: quem apertava "+" pelo teclado
     ou pelo leitor de tela caia no topo da pagina a cada toque. Antes da
     troca anota em qual linha e em qual controle o foco estava; depois
     devolve pro controle equivalente, ou pro "fechar" se ele sumiu. */
  function focoAntes() {
    var a = document.activeElement;
    if (!painel || !a || !painel.contains(a)) return null;
    var tipos = ['data-sth-mais', 'data-sth-menos', 'data-sth-tira', 'data-sth-add', 'data-sth-fechar'];
    var tipo = '';
    for (var i = 0; i < tipos.length; i++) { if (a.hasAttribute(tipos[i])) { tipo = tipos[i]; break; } }
    var li = a.closest('.sth-li');
    var linhas = painel.querySelectorAll('.sth-li');
    return { tipo: tipo, li: li ? Array.prototype.indexOf.call(linhas, li) : -1 };
  }
  function focoDepois(m) {
    if (!m || !painel) return;
    var alvo = null;
    if (m.tipo) {
      var caixa = m.li > -1 ? painel.querySelectorAll('.sth-li')[m.li] : painel;
      if (caixa) alvo = caixa.querySelector('[' + m.tipo + ']');
    }
    if (!alvo || alvo.disabled) alvo = painel.querySelector('.sth-sac__x') || painel.querySelector('[data-sth-checkout]');
    if (alvo) { try { alvo.focus({ preventScroll: true }); } catch (e) {} }
  }

  function repintar(html) {
    if (!painel) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresco = doc.querySelector('.sth-sac__in');
    /* silencio nao e sucesso: se a resposta nao trouxe o painel, o certo e
       recarregar em vez de deixar na tela um estado que ja nao e verdade. */
    if (!fresco) { window.location.reload(); return; }
    var marcaFoco = focoAntes();
    painel.innerHTML = fresco.outerHTML;
    focoDepois(marcaFoco);
    var novoIn = painel.querySelector('.sth-sac__in');
    if (novoIn) {
      novoIn.classList.add('is-novo');
      setTimeout(function () { novoIn.classList.remove('is-novo'); }, 900);
    }
    var n = doc.querySelector('[data-sth-conta]');
    if (n && conta) atualizarConta(parseInt(n.textContent, 10) || 0);
    ligarSacola();
    if (window.StellarEntrega) window.StellarEntrega.pintar(painel);
  }

  function atualizarConta(n) {
    if (!conta) return;
    conta.textContent = n;
    conta.classList.toggle('is-zero', n === 0);
    /* o rotulo acompanha a conta (G1-21) */
    var bt = conta.closest('[data-sth-sacola]');
    if (bt) bt.setAttribute('aria-label', n === 0 ? 'Carrinho, vazio' : (n === 1 ? 'Carrinho, 1 item' : 'Carrinho, ' + n + ' itens'));
    conta.classList.add('pula');
    setTimeout(function () { conta.classList.remove('pula'); }, 260);
  }

  function rota(caminho) {
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return raiz + caminho;
  }

  /* UMA IDA SO, EM VEZ DE TRES.

     O caminho antigo era: adiciona -> pergunta o carrinho -> pede a secao
     de volta. Tres viagens em fila, cada uma esperando a anterior: medi
     760 + 344 + 434 = 1.539ms so de rede, e no caso da escova ainda havia
     880ms de animacao ANTES da terceira comecar. Dava quase 2,5s.

     A API de carrinho da Shopify aceita pedir a secao renderizada junto
     da propria alteracao. Mesma chamada, mesma resposta: 617ms medidos.
     E a animacao passa a rodar EM CIMA da espera, nao depois dela. */
  function comSecao(corpo) {
    if (SECAO) {
      corpo.sections = SECAO;
      corpo.sections_url = window.location.pathname + window.location.search;
    }
    return corpo;
  }

  function htmlDaResposta(d) {
    return (d && d.sections && d.sections[SECAO]) || null;
  }

  /* MUDAR QUANTIDADE E REMOVER SAO A MESMA VIAGEM.

     As duas mexem no carrinho, pedem a secao de volta na mesma chamada e
     repintam o painel; so o corpo do pedido muda. Uma funcao so evita que
     um dia o tratamento de erro de uma fique diferente do da outra. */
  function mexer(caminho, corpo) {
    if (!painel) return;
    painel.classList.add('is-carregando');
    return fetch(rota(caminho), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(comSecao(corpo))
    })
      .then(function (r) { if (!r.ok) throw new Error('mexer'); return r.json(); })
      .then(function (d) {
        atualizarConta(d.item_count);
        var html = htmlDaResposta(d);
        if (html) return repintar(html);
        return fetch(window.location.pathname + '?section_id=' + SECAO)
          .then(function (r) { return r.text(); })
          .then(repintar);
      })
      .catch(function () {
        /* se a rede falhar, recarregar e melhor que mostrar total errado */
        window.location.reload();
      })
      .then(function () { painel.classList.remove('is-carregando'); });
  }

  function mudar(linha, qtd) {
    return mexer('cart/change.js', { line: linha, quantity: qtd });
  }

  /* REMOVER O PRODUTO INTEIRO, INCLUSIVE QUANDO ELE E DUAS LINHAS.

     O combo faz a Shopify partir a mesma variante em duas linhas, e o painel
     mostra uma so. Zerar por INDICE exigiria duas chamadas em fila, e o
     indice da segunda muda depois que a primeira some. `cart/update.js`
     aceita um mapa de chave -> quantidade: todas as linhas caem juntas, numa
     viagem, sem depender de ordem. */
  function tirar(chaves) {
    var zera = {};
    for (var i = 0; i < chaves.length; i++) zera[chaves[i]] = 0;
    return mexer('cart/update.js', { updates: zera });
  }

  /* ADICIONAR DE DENTRO DO PAINEL

     Vale pros dois lugares: o "+" dos modelos na sacola vazia e o botao da
     escova na sacola cheia. Os dois carregam data-sth-add com o id da
     variante, entao um handler so resolve.

     Quem tem data-sth-selo (a escova) mostra a confirmacao ANTES de repintar:
     o repintar troca o HTML inteiro e mataria a animacao no meio. Espero o
     selo terminar e so entao peco a secao de volta — que ja vem sem o convite,
     porque o Liquid esconde o upsell quando o produto ja esta na sacola. */
  var MC = parseFloat(getComputedStyle(root).getPropertyValue('--sth-mc')) || 2;

  /* O GESTO NAO ESPERA A REDE.

     Antes o selo so comecava quando a resposta chegava: o dedo saia do
     botao e por meio segundo nada acontecia — parecia que o toque nao
     tinha pegado. Agora a confirmacao dispara no clique e a chamada corre
     por baixo. Se der errado, desfaz. Errar as vezes custa menos que
     hesitar sempre. */
  function adicionar(botao) {
    var id = botao.getAttribute('data-sth-add');
    if (!id || botao.dataset.ocupado === 'sim') return;
    botao.dataset.ocupado = 'sim';

    var comSelo = botao.hasAttribute('data-sth-selo');
    var caixa = botao.closest('[data-sth-up]') || botao.closest('.sth-vitr');
    var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
    /* o selo tem um tempo minimo de tela. Se a resposta voltar antes, ele
       termina o gesto; se voltar depois, nao espera nada a mais. */
    var MINIMO = comSelo ? (520 * MC / 2 + 180) : 0;

    if (comSelo) {
      botao.classList.add('is-ok');
      if (caixa) caixa.classList.add('is-ok');
    } else {
      botao.disabled = true;
    }

    function agora() { return ((window.performance && performance.now) ? performance.now() : Date.now()) - t0; }

    fetch(rota('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(comSecao({ items: [{ id: parseInt(id, 10), quantity: 1 }] }))
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (d) {
        var html = htmlDaResposta(d);
        var falta = MINIMO - agora();
        if (falta < 0) falta = 0;
        return new Promise(function (ok) { setTimeout(function () { ok(html); }, falta); });
      })
      .then(function (html) {
        if (html) return repintar(html);
        return fetch(window.location.pathname + '?section_id=' + SECAO)
          .then(function (r) { return r.text(); })
          .then(repintar);
      })
      .catch(function () {
        botao.classList.remove('is-ok');
        if (caixa) caixa.classList.remove('is-ok');
        botao.disabled = false;
        botao.dataset.ocupado = '';
        window.location.reload();
      });
  }


  /* ══════════════════════════════════════════════════════════════════
     O CEP DA SACOLA — 16/08.

     Duas coisas novas moram aqui: a linha "Ver prazo de entrega" e o
     "Ver detalhes" do resumo. As duas nascem do HTML que o servidor
     manda, entao precisam ser religadas a cada repintura do painel.

     A cotacao reaproveita o MESMO contrato da pagina do produto:
       stlEntrega = { cep, cidade, uf, prazo, quando }   (7 dias)
     Quem consultou o CEP na pagina do PRO abre a sacola com o prazo ja
     preenchido, sem digitar de novo. E quem consulta aqui leva o dado
     pra pagina do produto. Uma consulta por pessoa, nao uma por tela.
     ══════════════════════════════════════════════════════════════════ */

  /* A faixa de CEP por UF e publica e fixa (plano de numeracao dos
     Correios). Ela existe porque a cotacao da Shopify exige o ESTADO, e
     porque o ViaCEP as vezes nao responde. Espelha a tabela de
     sections/stellar-pro-compra.liquid — com uma correcao: 78900-78999
     (Rondonia) faltava la e caia no vazio. */
  var STH_FAIXAS = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'],
    [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'],
    [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'],
    [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
    [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [78900, 78999, 'RO'], [79000, 79999, 'MS'],
    [80000, 87999, 'PR'], [88000, 89999, 'SC'], [90000, 99999, 'RS']
  ];
  function sthUf(cep) {
    var n = parseInt(String(cep).slice(0, 5), 10);
    if (!(n > 0)) return '';
    for (var i = 0; i < STH_FAIXAS.length; i++) {
      if (n >= STH_FAIXAS[i][0] && n <= STH_FAIXAS[i][1]) return STH_FAIXAS[i][2];
    }
    return '';
  }
  function sthCepFmt(v) {
    var d = String(v || '').replace(/\D/g, '').slice(0, 8);
    return d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  }
  /* DIAS UTEIS, NAO DIAS CORRIDOS.
     A Frenet devolve prazo em dias uteis e a pagina do produto ja escreve
     assim ("5 dias uteis"). Dizer so "5 dias" numa sexta-feira vira uma
     promessa que a transportadora nao fez — e prazo de entrega e promessa
     sobre dinheiro. As duas telas passam a contar a mesma coisa. */
  function sthPrazo(d) { return d > 1 ? d + ' dias úteis' : '1 dia útil'; }

  /* Grava no mesmo lugar que a pagina do produto le.

     A CIDADE E FRAGIL DE PROPOSITO. Ela so vem do ViaCEP, que e um servico
     de fora e pode nao responder — a cotacao segue sem ela, porque o prazo
     e o que importa aqui. Mas a pagina do produto usa a cidade pra falar
     pelo nome do lugar, e `StellarEntrega.ler()` descarta o registro
     inteiro quando ela falta.

     Entao, sem cidade nova, a antiga do MESMO CEP e preservada. Sem isso
     uma consulta feita aqui com o ViaCEP fora do ar apagaria silenciosamente
     a personalizacao que a pagina do produto ja tinha conquistado. */
  function sthLerCru() {
    try {
      var g = JSON.parse(localStorage.getItem('stlEntrega') || 'null');
      if (!g || !g.prazo || !g.quando) return null;
      if (Date.now() - g.quando > 7 * 24 * 60 * 60 * 1000) return null;
      return g;
    } catch (e) { return null; }
  }
  function sthGuardar(g) {
    if (!g.cidade) {
      var velho = sthLerCru();
      if (velho && velho.cep === g.cep && velho.cidade) g.cidade = velho.cidade;
    }
    try { localStorage.setItem('stlEntrega', JSON.stringify(g)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('stellar:entrega'));
  }

  /* A COTACAO.

     Usa a rota SINCRONA. A pagina do produto usa a assincrona porque la
     ela precisa trocar o carrinho pelo produto da pagina e devolver
     depois; aqui o carrinho JA e o que a pessoa quer cotar, entao nao ha
     nada pra salvar nem restaurar — e a resposta vem de primeira.

     Mostra so a opcao gratuita: a pessoa nao esta escolhendo
     transportadora, esta decidindo se vale a pena esperar. */
  function sthCotar(cep, uf) {
    /* sem a barra inicial: rota() ja devolve a raiz da loja, e com ela o
       endereco viraria "//cart/..." — que o navegador le como outro dominio. */
    var q = 'cart/shipping_rates.json'
          + '?shipping_address%5Bzip%5D=' + encodeURIComponent(cep)
          + '&shipping_address%5Bcountry%5D=Brazil'
          + '&shipping_address%5Bprovince%5D=' + encodeURIComponent(uf);
    return fetch(rota(q), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var t = (j && j.shipping_rates) || [];
        if (!t.length) return null;
        var gratis = null;
        for (var i = 0; i < t.length; i++) {
          if (parseFloat(t[i].price) === 0) { gratis = t[i]; break; }
        }
        var alvo = gratis || t[0];
        var dd = alvo.delivery_days;
        var dias = 0;
        if (dd && dd.length) dias = parseInt(dd[dd.length - 1], 10) || 0;
        return { dias: dias, gratis: !!gratis };
      })
      .catch(function () { return null; });
  }

  function ligarFrete() {
    if (!painel) return;
    var bloco = painel.querySelector('[data-sth-frete]');
    if (!bloco) return;
    var abrir  = bloco.querySelector('[data-sth-frete-abrir]'),
        campo  = bloco.querySelector('[data-sth-cep]'),
        botao  = bloco.querySelector('[data-sth-cep-ok]'),
        aviso  = bloco.querySelector('[data-sth-cep-aviso]'),
        caixa  = bloco.querySelector('[data-sth-frete-ok]'),
        txt    = bloco.querySelector('[data-sth-frete-txt]'),
        vaoCep = bloco.querySelector('[data-sth-frete-cep]'),
        trocar = bloco.querySelector('[data-sth-frete-trocar]');

    function mostrarConvite() {
      if (caixa) caixa.hidden = true;
      if (abrir) abrir.hidden = false;
    }
    /* O "gratis" sai em verde: e a palavra que ela veio conferir. */
    function mostrarPrazo(g) {
      if (!caixa || !txt) return;
      var frase = g.gratis === false
        ? 'Faça seu pedido. Chega em ' + sthPrazo(g.prazo) + '.'
        : 'Faça seu pedido. Chega em ' + sthPrazo(g.prazo) + ', <span class="sth-gr">grátis</span>.';
      txt.innerHTML = frase;
      if (vaoCep) vaoCep.textContent = sthCepFmt(g.cep);
      caixa.hidden = false;
      if (abrir) abrir.hidden = true;
      bloco.classList.remove('aberto');
      pesarGaveta();
      if (abrir) abrir.setAttribute('aria-expanded', 'false');
    }

    /* Abre a sacola ja resolvida quando a pessoa ja consultou antes —
       na pagina do produto ou aqui mesmo. */
    /* Le o registro cru, e nao StellarEntrega.ler(): aquele exige cidade,
       que aqui nao faz falta. A sacola so precisa do prazo. */
    /* A gaveta do CEP fechada tem altura zero, mas o campo continuava no Tab
       (Raio-X G1-12, 30/09): fechada, ela fica `inert`. */
    var gavCep = bloco.querySelector('.sth-acao__gav');
    function pesarGaveta() { if (gavCep) gavCep.inert = !bloco.classList.contains('aberto'); }

    var salvo = sthLerCru();
    if (salvo && salvo.prazo) mostrarPrazo(salvo); else mostrarConvite();
    pesarGaveta();

    if (abrir) abrir.addEventListener('click', function () {
      var aberto = bloco.classList.toggle('aberto');
      abrir.setAttribute('aria-expanded', String(aberto));
      pesarGaveta();
      if (aberto && campo) setTimeout(function () { campo.focus(); }, 120);
    });
    if (trocar) trocar.addEventListener('click', function () {
      mostrarConvite();
      bloco.classList.add('aberto');
      pesarGaveta();
      if (abrir) abrir.setAttribute('aria-expanded', 'true');
      if (campo) { campo.value = ''; pesarBotao(); setTimeout(function () { campo.focus(); }, 120); }
    });
    /* O BOTAO SO ACENDE COM O CEP INTEIRO — 16/08.
       Vem junto do desenho da pagina de produto: la o "Calcular" nasce
       apagado e so ganha o preto quando os 8 numeros estao la. Sem isso o
       botao ficava sempre aceso e o unico retorno de um CEP pela metade era
       um toque que devolvia erro. O estado tambem E o desenho: com dois
       tons, o campo diz sozinho o que ainda falta. */
    function pesarBotao() {
      if (!botao || !campo) return;
      botao.disabled = String(campo.value || '').replace(/\D/g, '').length !== 8;
    }
    pesarBotao();

    if (campo) campo.addEventListener('input', function () {
      campo.value = sthCepFmt(campo.value);
      pesarBotao();
      if (aviso) { aviso.textContent = ''; aviso.classList.remove('erro'); }
    });

    var enviando = false;
    function consultar() {
      if (enviando) return;
      var cep = String(campo && campo.value || '').replace(/\D/g, '');
      if (cep.length !== 8) {
        if (aviso) { aviso.textContent = 'Digite os 8 números do CEP.'; aviso.classList.add('erro'); }
        if (campo) campo.focus();
        return;
      }
      enviando = true;
      if (botao) botao.disabled = true;
      if (aviso) { aviso.textContent = 'Consultando…'; aviso.classList.remove('erro'); }

      /* O ViaCEP da a cidade — que a pagina do produto usa pra falar pelo
         nome do lugar. Se ele demorar, a faixa resolve o estado sozinha e
         a cotacao segue: o prazo importa mais que o nome da cidade. */
      var cidade = '', uf = '';
      var corte = new AbortController();
      var relogio = setTimeout(function () { corte.abort(); }, 2500);
      fetch('https://viacep.com.br/ws/' + cep + '/json/', { signal: corte.signal })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (v) {
          clearTimeout(relogio);
          if (v && !v.erro) { uf = v.uf || ''; cidade = v.localidade || ''; }
          if (!uf) uf = sthUf(cep);
          if (!uf) throw new Error('sem uf');
          return sthCotar(cep, uf);
        })
        .then(function (r) {
          enviando = false;
          pesarBotao();   /* volta ao estado do campo, nao a "aceso" */
          if (!r || !r.dias) {
            if (aviso) { aviso.textContent = 'Não conseguimos calcular para esse CEP agora.'; aviso.classList.add('erro'); }
            return;
          }
          if (aviso) { aviso.textContent = ''; aviso.classList.remove('erro'); }
          var g = { cep: cep, cidade: cidade, uf: uf, prazo: r.dias, quando: Date.now() };
          sthGuardar(g);
          g.gratis = r.gratis;
          mostrarPrazo(g);
        })
        .catch(function () {
          enviando = false;
          pesarBotao();   /* volta ao estado do campo, nao a "aceso" */
          if (aviso) { aviso.textContent = 'Não conseguimos calcular para esse CEP agora.'; aviso.classList.add('erro'); }
        });
    }
    if (botao) botao.addEventListener('click', consultar);
    if (campo) campo.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); consultar(); }
    });
  }

  /* O extrato do resumo. Fechado por padrao: quem so quer pagar, paga. */
  function ligarDetalhe() {
    if (!painel) return;
    var bt = painel.querySelector('[data-sth-detalhe]');
    var cx = painel.querySelector('[data-sth-detalhe-caixa]');
    if (!bt || !cx) return;
    bt.addEventListener('click', function () {
      var aberto = cx.hidden;
      cx.hidden = !aberto;
      bt.setAttribute('aria-expanded', String(aberto));
    });
  }


  /* ── A ESCOLHA DENTRO DA SACOLA ──────────────────────────────────────
     O "+" da vitrine deixou de adicionar direto: ele abre cor e voltagem
     ali mesmo. Cor troca o GRUPO de voltagens visivel, porque Rosa e Verde
     sao produtos diferentes na Shopify — cada um com as variantes dele.

     O botao de confirmar reaproveita `adicionar()`: basta escrever o id da
     variante escolhida no proprio botao antes de chamar. Assim o selo, o
     tempo minimo de animacao e a repintura do painel continuam sendo os
     mesmos do resto da sacola, sem um segundo caminho pra manter. */
  function ligarEscolha() {
    if (!painel) return;

    /* `hidden` nao anima — ele e um interruptor. Quem anima e a classe, e o
       `hidden` fica so nas duas pontas: sai ANTES de abrir (senao nao ha o
       que animar) e volta DEPOIS de fechar, pra gaveta recolhida nao pegar
       o Tab. O guarda de tempo cancela o retorno se a pessoa reabrir no meio
       do fecho. */
    var ABRE = 460, FECHA = 500;

    function abrirEsc(esc) {
      if (esc._sthT) { clearTimeout(esc._sthT); esc._sthT = null; }
      esc.hidden = false;
      /* dois quadros: no primeiro o elemento acabou de deixar de ser
         `display:none` e o navegador ainda nao tem um valor de onde partir —
         a transicao nasceria morta. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { esc.classList.add('is-aberta'); });
      });
      /* a gaveta que abre no pe da lista nasce fora da vista. `nearest` rola
         o minimo possivel: se ja estiver inteira na tela, nao mexe em nada. */
      esc._sthR = setTimeout(function () {
        try { esc.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
      }, ABRE / 2);
    }

    function fecharEsc(esc) {
      if (esc._sthR) { clearTimeout(esc._sthR); esc._sthR = null; }
      esc.classList.remove('is-aberta');
      if (esc._sthT) clearTimeout(esc._sthT);
      esc._sthT = setTimeout(function () { esc.hidden = true; esc._sthT = null; }, FECHA);
      var c = esc.closest('.sth-vitr');
      if (c) c.classList.remove('is-escolhendo');
      var b = c && c.querySelector('[data-sth-escolher]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }

    painel.querySelectorAll('[data-sth-escolher]').forEach(function (bt) {
      var card = bt.closest('.sth-vitr');
      var esc = card && card.querySelector('[data-sth-esc]');
      if (!esc) return;
      bt.addEventListener('click', function () {
        var abrindo = !esc.classList.contains('is-aberta');
        if (!abrindo) { fecharEsc(esc); return; }
        /* fecha a escolha do outro modelo: duas abertas ao mesmo tempo
           empurram o rodape pra fora e ninguem compara dois modelos
           escolhendo voltagem nos dois. */
        painel.querySelectorAll('[data-sth-esc]').forEach(function (o) {
          if (o !== esc) fecharEsc(o);
        });
        abrirEsc(esc);
        bt.setAttribute('aria-expanded', 'true');
        card.classList.add('is-escolhendo');
      });
    });

    painel.querySelectorAll('[data-sth-esc]').forEach(function (esc) {
      var aviso = esc.querySelector('[data-sth-esc-aviso]');

      var cardEsc = esc.closest('.sth-vitr');
      var luzEsc = cardEsc && cardEsc.querySelector('.sth-vitr__luz');
      var fotoEsc = cardEsc && cardEsc.querySelector('.sth-vitr__foto img');

      esc.querySelectorAll('[data-sth-cor]').forEach(function (b) {
        b.addEventListener('click', function () {
          esc.querySelectorAll('[data-sth-cor]').forEach(function (o) {
            o.setAttribute('aria-pressed', String(o === b));
          });
          esc.querySelectorAll('[data-sth-gr]').forEach(function (g) {
            g.hidden = g.getAttribute('data-sth-gr') !== b.getAttribute('data-sth-cor');
          });
          /* o nome da linha veste a cor escolhida. Escrever as duas
             variaveis no proprio elemento faz a transicao registrada rodar;
             a classe do pulso e removida no fim pra poder repetir na
             proxima troca (animacao so reinicia se sair e voltar). */
          var na = b.getAttribute('data-sth-nome');
          if (luzEsc && na) {
            luzEsc.style.setProperty('--sth-nome-a', na);
            luzEsc.style.setProperty('--sth-nome-b', b.getAttribute('data-sth-nome-luz') || na);
            luzEsc.classList.remove('is-trocando');
            void luzEsc.offsetWidth;
            luzEsc.classList.add('is-trocando');
            setTimeout(function () { luzEsc.classList.remove('is-trocando'); }, 620);
          }
          /* A FOTO ACOMPANHA O NOME.
             O `src` so troca depois que a nova imagem terminou de carregar
             — trocar antes mostraria o quadro vazio por um instante na
             primeira vez de cada cor, justamente quando ninguem tem a
             imagem em cache. Enquanto a nova nao chega, a antiga continua
             na tela e nada pisca. */
          var nf = b.getAttribute('data-sth-foto');
          if (fotoEsc && nf && fotoEsc.getAttribute('src') !== nf) {
            var pre = new Image();
            pre.onload = function () {
              fotoEsc.classList.add('is-trocando');
              setTimeout(function () {
                fotoEsc.src = nf;
                fotoEsc.classList.remove('is-trocando');
              }, 190);
            };
            pre.src = nf;
          }
          /* E o destino tambem: a foto e o nome sao links, e apontavam pro
             primeiro produto da lista qualquer que fosse a cor marcada. */
          var nu = b.getAttribute('data-sth-url');
          if (nu && cardEsc) {
            cardEsc.querySelectorAll('.sth-vitr__foto, .sth-vitr__nome').forEach(function (a) {
              a.setAttribute('href', nu);
            });
          }
          if (aviso) aviso.textContent = '';
        });
      });

      esc.querySelectorAll('[data-sth-v]').forEach(function (b) {
        b.addEventListener('click', function () {
          var g = b.closest('[data-sth-gr]');
          if (!g) return;
          g.querySelectorAll('[data-sth-v]').forEach(function (o) {
            o.setAttribute('aria-pressed', String(o === b));
          });
          if (aviso) aviso.textContent = '';
        });
      });

      var ok = esc.querySelector('[data-sth-esc-ok]');
      if (ok) ok.addEventListener('click', function () {
        var g = esc.querySelector('[data-sth-gr]:not([hidden])');
        var v = g && g.querySelector('[data-sth-v][aria-pressed="true"]:not([disabled])');
        if (!v) {
          if (aviso) aviso.textContent = 'Escolha uma voltagem disponível.';
          return;
        }
        ok.setAttribute('data-sth-add', v.getAttribute('data-sth-v'));
        adicionar(ok);
      });
    });
  }


  /* O rodape flutua por cima da lista, entao o corpo precisa saber de quanto
     desviar. A altura muda (com e sem parcelamento), por isso e medida e nao
     escrita. Roda a cada repintura e em cada giro de tela. */
  var obsRodape = null;
  function medirRodape() {
    if (!painel) return;
    /* `[data-sth-sac]` E o `.sth-sac` — nao um pai dele. Procurar por dentro
       devolvia null e a funcao saia calada: o corpo ficava com os 150px de
       reserva contra um rodape de 184px, e as ultimas linhas da conta
       dormiam embaixo do vidro pra sempre. */
    var sac = painel.matches('.sth-sac') ? painel : (painel.querySelector('.sth-sac') || painel);
    var pe = painel.querySelector('.sth-sac__pe');
    if (!pe) { sac.style.setProperty('--sth-pe-h', '0px'); return; }

    /* Fechado, o painel nao tem altura — medir aqui daria zero. O observador
       reage quando ele ganha tamanho de verdade (ao abrir) e a cada vez que o
       rodape muda de altura, que e o que acontece quando o parcelamento
       aparece ou some. */
    if (window.ResizeObserver) {
      if (obsRodape) obsRodape.disconnect();
      obsRodape = new ResizeObserver(function () {
        var h = Math.round(pe.getBoundingClientRect().height);
        if (h > 0) sac.style.setProperty('--sth-pe-h', h + 'px');
      });
      obsRodape.observe(pe);
    }
    var h0 = Math.round(pe.getBoundingClientRect().height);
    if (h0 > 0) sac.style.setProperty('--sth-pe-h', h0 + 'px');
  }
  window.addEventListener('resize', medirRodape);

  function ligarSacola() {
    if (!painel) return;
    medirRodape();
    ligarEscolha();
    ligarFrete();
    ligarDetalhe();
    painel.querySelectorAll('[data-sth-fechar]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); fechar(); });
    });
    painel.querySelectorAll('[data-sth-fechar-link]').forEach(function (a) {
      a.addEventListener('click', function () { fechar(false); });
    });
    painel.querySelectorAll('[data-sth-add]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); adicionar(b); });
    });
    var cup = painel.querySelector('[data-sth-cupom]');
    if (cup) {
      var campo = cup.querySelector('input'),
          botao = cup.querySelector('[data-sth-cupom-ok]'),
          abrir = cup.querySelector('[data-sth-cupom-abrir]'),
          aviso = cup.querySelector('[data-sth-cupom-aviso]');
      if (abrir) abrir.addEventListener('click', function () {
        var aberto = cup.classList.toggle('aberto');
        abrir.setAttribute('aria-expanded', String(aberto));
        if (aberto) setTimeout(function () { campo.focus(); }, 120);
      });
      var enviar = function () {
        var codigo = (campo.value || '').trim();
        if (!codigo) { campo.focus(); return; }
        botao.disabled = true;
        if (aviso) { aviso.textContent = 'Conferindo…'; aviso.classList.remove('erro'); }
        /* A CAIXINHA PAROU DE ADIVINHAR — 15/08.

           Antes: aplicava por /discount/CODIGO e comparava o total de antes
           com o de depois pra deduzir se pegou. Essa rota nao responde nada
           sobre o codigo, e bastava o desconto demorar um instante pra
           comparacao dar igual — a caixinha acusava de invalido um cupom bom.

           Agora quem responde e a Shopify: /cart/update.js aceita `discount`
           e devolve `discount_codes: [{code, applicable}]`. Sem palpite. E
           como a mesma chamada ja traz a secao renderizada, o painel se
           repinta na volta, sem uma segunda viagem. */
        fetch(rota('cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(comSecao({ discount: codigo }))
        })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var lista = d.discount_codes || [];
            var alvo = null;
            for (var i = 0; i < lista.length; i++) {
              if (String(lista[i].code || '').toUpperCase() === codigo.toUpperCase()) { alvo = lista[i]; break; }
            }
            /* sem a lista (loja antiga, resposta cortada) sobra o sinal
               indireto: houve desconto, entao alguma coisa pegou. */
            var pegou = alvo ? alvo.applicable !== false : (d.total_discount || 0) > 0;
            if (!pegou) {
              botao.disabled = false;
              if (aviso) { aviso.textContent = 'Não encontramos esse cupom.'; aviso.classList.add('erro'); }
              return;
            }
            if (aviso) { aviso.textContent = ''; aviso.classList.remove('erro'); }
            atualizarConta(d.item_count);
            return refrescar(htmlDaResposta(d));
          })
          .catch(function () {
            botao.disabled = false;
            if (aviso) { aviso.textContent = 'Não deu para conferir agora. Tente de novo.'; aviso.classList.add('erro'); }
          });
      };
      botao.addEventListener('click', enviar);
      campo.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); enviar(); } });

      /* TIRAR O CUPOM.

         Mesma rota que aplica, com o codigo vazio: a Shopify entende como
         "esqueca o que eu digitei". Medido: com SOUFUNDADOR o total era
         2.250,00; depois do vazio, discount_codes volta a [] e o total a
         2.499,99.

         Passa pelo `mexer` como qualquer outra alteracao, entao ja pede a
         secao de volta na mesma viagem e o painel se repinta sem o recibo. */
      var tira = cup.querySelector('[data-sth-cupom-tira]');
      if (tira) tira.addEventListener('click', function () {
        tira.disabled = true;
        if (aviso) { aviso.textContent = ''; aviso.classList.remove('erro'); }
        mexer('cart/update.js', { discount: '' });
      });
    }

    /* UM ITEM NA TELA, AS VEZES DUAS LINHAS NO CARRINHO.

       O desconto de combo faz a Shopify separar a unidade que disparou a
       promocao numa linha propria. O painel junta as duas de volta num
       item so (ver stellar-sacola), mas o cart/change.js continua falando
       por indice de linha — entao cada item carrega a lista real.

       O "+" cresce na primeira linha; o "-" encolhe a ultima que ainda tem
       unidade. Assim o numero na tela sobe e desce de um em um, que e o
       que a pessoa espera ver, sem precisar saber que existiam duas. */
    painel.querySelectorAll('.sth-li').forEach(function (li) {
      var visivel = parseInt(li.querySelector('.sth-qtd b').textContent, 10) || 1;
      var linhas = String(li.dataset.linhas || li.dataset.linha || '')
        .split(',')
        .map(function (x) { return parseInt(x, 10); })
        .filter(function (x) { return x > 0; });
      if (!linhas.length) return;
      var qtds = String(li.dataset.qtds || '')
        .split(',')
        .map(function (x) { return parseInt(x, 10) || 0; });
      if (qtds.length !== linhas.length) qtds = linhas.map(function () { return visivel; });
      var menos = li.querySelector('[data-sth-menos]');
      var mais = li.querySelector('[data-sth-mais]');
      var tira = li.querySelector('[data-sth-tira]');
      var chaves = String(li.dataset.chaves || '').split(',').filter(Boolean);
      if (tira) tira.addEventListener('click', function () {
        if (chaves.length) tirar(chaves);
      });
      if (mais) mais.addEventListener('click', function () { mudar(linhas[0], qtds[0] + 1); });
      if (menos) menos.addEventListener('click', function () {
        for (var i = linhas.length - 1; i >= 0; i--) {
          if (qtds[i] > 0) { mudar(linhas[i], qtds[i] - 1); return; }
        }
      });
    });
  }
  ligarSacola();

  /* PONTE PRA FORA DO CABECALHO

     Quem manda no carrinho e este arquivo, e so ele. A pagina do PRO tem o
     proprio botao de "adicionar a sacola", e a alternativa seria ela refazer
     a mesma chamada e repintar o painel por conta propria — dois donos do
     mesmo estado, que e como um deles fica desatualizado sem ninguem notar.
     Em vez disso o cabecalho publica tres verbos e continua sendo o dono:
     `secao` (o id que a API de renderizacao precisa), `repintar` (troca o
     conteudo do painel e ja acerta o contador) e `abrir`.

     Se o cabecalho nao existir na pagina, quem chama cai no plano B — por
     isso a ponte e sempre checada antes de usar, nunca assumida. */
  /* `refrescar` e o `repintar` com o plano B embutido. A API de carrinho as
     vezes devolve `sections: null` mesmo com o id certo no pedido — e o que
     acontece na previa do tema, por exemplo. Quando isso ocorre, o jeito e
     pedir a secao pela rota de renderizacao. Quem chama de fora nao precisa
     saber de nada disso: entrega o que veio, mesmo que seja nada. */
  function refrescar(html) {
    if (html) return repintar(html);
    return fetch(window.location.pathname + '?section_id=' + SECAO)
      .then(function (r) { return r.text(); })
      .then(repintar);
  }

  window.StellarSacola = {
    secao: SECAO,
    repintar: repintar,
    refrescar: refrescar,
    conta: atualizarConta,
    abrir: function () { abrir('is-sacola'); }
  };

  /* ── A ENTREGA QUE A PESSOA JA CONSULTOU ────────────────────────────
     Quando alguem cota o frete na pagina do PRO, a cidade e o prazo do
     frete gratis ficam guardados. Daqui em diante a loja inteira pode
     falar com ela pelo nome do lugar onde mora.

     Sete dias de validade: passado isso a tabela da transportadora pode
     ter mudado, e um prazo velho vira promessa falsa. O contrato da chave
     e o mesmo escrito em sections/stellar-pro-compra.liquid. */
  var StellarEntrega = (function () {
    var CHAVE = 'stlEntrega', VALE = 7 * 24 * 60 * 60 * 1000;
    function ler() {
      try {
        var g = JSON.parse(localStorage.getItem(CHAVE) || 'null');
        if (!g || !g.cidade || !g.prazo || !g.quando) return null;
        if (Date.now() - g.quando > VALE) { localStorage.removeItem(CHAVE); return null; }
        return g;
      } catch (e) { return null; }
    }
    function prazo(d) { return d > 1 ? d + ' dias úteis' : '1 dia útil'; }
    /* {dias} é o mesmo número sem "úteis" — pedido do Romulo, 17/08, pra
       faixa do topo caber em "Frete grátis, 9 dias até você".
       O plural continua sendo tratado aqui e não no molde: 1 dia, 2 dias.
       Aviso registrado: a Frenet devolve DIAS ÚTEIS. Escrever só "dias" faz
       a loja prometer um prazo corrido que a transportadora não deu — nove
       dias úteis são quase duas semanas de calendário. {prazo} continua
       existindo pra onde a promessa precisar estar inteira. */
    function dias(d) { return d > 1 ? d + ' dias' : '1 dia'; }
    function frase(molde, g) {
      if (!molde || !g) return '';
      return molde.replace('{cidade}', g.cidade)
                  .replace('{prazo}', prazo(g.prazo))
                  .replace('{dias}', dias(g.prazo));
    }
    return { ler: ler, frase: frase, prazo: prazo, dias: dias };
  })();
  window.StellarEntrega = StellarEntrega;

  /* A SACOLA FALA DA CIDADE DELA.
     Roda no carregamento e depois de cada repintura do painel — o HTML da
     sacola volta do servidor sem saber de nada. */
  function personalizarEntrega(raiz) {
    var g = StellarEntrega.ler();
    var lista = (raiz || document).querySelectorAll('[data-sth-entrega]');
    Array.prototype.forEach.call(lista, function (el) {
      var molde = el.getAttribute(g ? 'data-modelo-cep' : 'data-modelo-geral');
      var txt = g ? StellarEntrega.frase(molde, g) : molde;
      if (!txt) { el.hidden = true; return; }
      var vao = el.querySelector('[data-sth-entrega-txt]');
      if (vao) vao.textContent = txt; else el.textContent = txt;
      el.hidden = false;
    });
  }
  StellarEntrega.pintar = personalizarEntrega;
  personalizarEntrega();
  document.addEventListener('stellar:entrega', function () { personalizarEntrega(); });

  /* -----------------------------------------------------------------
     QUANDO O CARRINHO MUDA FORA DAQUI

     O que estava aqui antes ouvia 'cart:updated' e so mexia no contador.
     Dois problemas, os dois medidos no site que esta no ar:

     1. O nome do evento estava errado. O tema dispara 'cart:update'
        (sem o D final), no <product-form-component>. Como o evento
        borbulha, ouvir no document funciona — mas so com o nome certo.
        Com o nome errado nada acontecia: adicionar a Escova Plume pela
        pagina do produto deixava a bolsa marcando zero.

     2. Mesmo com o nome certo, mexer so no contador nao bastava. O painel
        da sacola e HTML renderizado no servidor quando a pagina carregou.
        Se o carrinho mudou depois disso, o painel esta velho: abri a
        sacola com um item dentro e ela mostrava carrinho vazio.

     Por isso agora sao duas coisas. O evento marca o painel como velho e,
     se ele estiver aberto, repinta na hora. E abrir a sacola repinta se
     ela estiver velha — essa segunda parte e a que garante o resultado
     mesmo quando o caminho de adicao nao dispara evento nenhum, que e o
     caso de varios botoes de tema e de app. Nao da para prever todos;
     da para nunca mostrar um numero que nao e verdade.

     Repintar tem custo de uma requisicao. Por isso o marcador: sacola
     aberta e ja fresca nao busca nada. -------------------------------- */
  var sacolaVelha = false;

  function cartMudou(e) {
    if (e && e.detail && typeof e.detail.item_count === 'number') atualizarConta(e.detail.item_count);
    else {
      fetch(rota('cart.js'), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { atualizarConta(d.item_count); })
        .catch(function () {});
    }
    sacolaVelha = true;
    if (root.classList.contains('is-sacola')) { sacolaVelha = false; refrescar(); }
  }
  ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (nome) {
    document.addEventListener(nome, cartMudou);
  });
  root.addEventListener('sth:abriu', function () {
    if (root.classList.contains('is-sacola') && sacolaVelha) { sacolaVelha = false; refrescar(); }
  });

  /* -----------------------------------------------------------------
     O CUPOM NA PAGINA DO CARRINHO

     O campo de cupom da pagina /cart e do proprio tema. Medindo o que ele
     faz: manda o codigo, a Shopify aplica de verdade (o total no /cart.js
     realmente baixa), e a tela nao muda — nenhuma requisicao de secao sai,
     nenhum aviso aparece, o codigo digitado fica no campo. Quem usa ve o
     botao trabalhar e nada acontecer, e conclui que o cupom nao vale.

     Entao o envio passa a ser nosso. A rota /cart/update.js aceita o
     codigo e devolve, na mesma resposta, o HTML da secao do carrinho ja
     recalculado — e e esse HTML que substitui a secao na tela.

     COMO SABER SE O CUPOM PEGOU
     Nao da para perguntar. Codigo invalido tambem responde 200, sem erro
     e sem mensagem. A unica forma honesta e comparar o carrinho antes e
     depois: se o desconto nao aumentou, o cupom nao existe ou nao vale
     para o que esta na sacola. E isso que a mensagem diz.

     So roda onde ha o campo do tema. Em qualquer outra pagina, sai fora
     sem custo. --------------------------------------------------------- */
  function ligarCupomDaPagina() {
    var comp = document.querySelector('cart-discount-component');
    if (!comp || comp.dataset.sthCupom === 'sim') return;
    var campo = comp.querySelector('input[name="discount"]');
    var forma = campo && campo.closest('form');
    if (!campo || !forma) return;
    comp.dataset.sthCupom = 'sim';

    var aviso = document.createElement('p');
    aviso.className = 'sth-cupago';
    aviso.setAttribute('role', 'status');
    aviso.setAttribute('aria-live', 'polite');
    forma.insertAdjacentElement('afterend', aviso);

    var caixa = document.querySelector('cart-items-component');
    var secao = caixa && caixa.getAttribute('data-section-id');

    function fala(txt, ruim) {
      aviso.textContent = txt || '';
      aviso.classList.toggle('is-ruim', !!ruim);
    }

    function aplicar() {
      var codigo = (campo.value || '').trim();
      if (!codigo) { campo.focus(); return; }
      var botao = forma.querySelector('button');
      if (botao) botao.disabled = true;
      fala('Conferindo…', false);

      fetch(rota('cart.js'), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (antes) {
          var corpo = { discount: codigo };
          if (secao) { corpo.sections = secao; corpo.sections_url = '/cart'; }
          return fetch(rota('cart/update.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(corpo)
          })
            .then(function (r) { return r.json(); })
            .then(function (d) {
              return fetch(rota('cart.js'), { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (depois) { return { d: d, antes: antes, depois: depois }; });
            });
        })
        .then(function (par) {
          if (botao) botao.disabled = false;
          var ganhou = (par.depois.total_discount || 0) > (par.antes.total_discount || 0);
          if (!ganhou) {
            fala('Não encontramos esse cupom, ou ele não vale para o que está na sacola.', true);
            return;
          }
          var html = secao && par.d.sections && par.d.sections[secao];
          if (!html) { window.location.reload(); return; }
          var nova = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items-component');
          if (!nova) { window.location.reload(); return; }
          caixa.replaceWith(nova);
          ligarCupomDaPagina();
          var novoAviso = document.querySelector('.sth-cupago');
          if (novoAviso) { novoAviso.textContent = 'Cupom ' + codigo.toUpperCase() + ' aplicado.'; novoAviso.classList.remove('is-ruim'); }
          document.dispatchEvent(new CustomEvent('cart:update', { detail: { item_count: par.depois.item_count } }));
        })
        .catch(function () {
          if (botao) botao.disabled = false;
          fala('Não deu para conferir agora. Tente de novo.', true);
        });
    }

    forma.addEventListener('submit', function (e) { e.preventDefault(); aplicar(); }, true);
    var bt = forma.querySelector('button');
    if (bt) bt.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); aplicar(); }, true);
    campo.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); aplicar(); } }, true);
  }
  ligarCupomDaPagina();
  document.addEventListener('DOMContentLoaded', ligarCupomDaPagina);
  setTimeout(ligarCupomDaPagina, 1200);

  /* ---------------------------------------------------------------
     A FAIXA DE AVISOS
     Ela entra depois do carregamento, e nao ja aberta: o gesto de sair
     de dentro da barra e metade do recado. Se ja estivesse la quando a
     pagina aparece, seria so mais uma tarja.
     Os tempos vem do editor por data-attribute — este arquivo e um
     asset compilado, entao nao ve Liquid.
  ---------------------------------------------------------------- */
  (function () {
    var caixa = root.querySelector('[data-sth-aviso]');
    if (!caixa) return;

    var atraso = parseInt(caixa.getAttribute('data-atraso'), 10);
    if (isNaN(atraso)) atraso = 700;
    setTimeout(function () { root.classList.add('is-av'); }, atraso);

    /* A MENSAGEM QUE E SO DELA ENTRA NO FIM DA FILA.
       Depois de cotar o frete, a barra passa a fechar o ciclo dizendo o
       prazo ate a cidade dela. Por ultimo de proposito: os recados da loja
       continuam sendo os primeiros, e o reconhecimento vem como remate.
       Precisa entrar ANTES da consulta abaixo — o rodizio conta os
       elementos uma vez so, na largada. */
    (function () {
      var molde = caixa.getAttribute('data-av-entrega');
      if (!molde) return;
      var g = StellarEntrega.ler();
      if (!g) return;
      var fita = caixa.querySelector('.sth-av__fita');
      if (!fita) return;
      /* Sem o caminhãozinho — pedido do Romulo, 17/08. A faixa tem uma linha
         de altura e um texto curto; o ícone competia com a frase pelo mesmo
         espaço e não acrescentava nada que a palavra "frete" já não diga.
         O <span> continua existindo porque é ele que o rodízio troca. */
      var p = document.createElement('p');
      p.className = 'sth-av__m';
      p.innerHTML = '<span></span>';
      p.querySelector('span').textContent = StellarEntrega.frase(molde, g);
      fita.appendChild(p);
    })();

    var msgs = caixa.querySelectorAll('.sth-av__m');
    if (msgs.length < 2) return;

    /* "Reduzir movimento" ligado: a faixa fica na primeira mensagem e nao
       gira (Raio-X G4-12, 30/09). */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var troca = parseFloat(caixa.getAttribute('data-troca'));
    if (isNaN(troca) || troca < 2) troca = 5;

    var i = 0;
    var relogio = setInterval(girar, troca * 1000);
    function girar() {
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }
    /* aba escondida nao precisa de rodizio rodando a toa */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearInterval(relogio);
      } else {
        clearInterval(relogio);
        relogio = setInterval(girar, troca * 1000);
      }
    });
  })();

  /* ---------------------------------------------------------------
     A FILEIRA DA CONTA AVISA QUE TEM MAIS - ATE ACABAR.
     A mascara de desvanecer na direita so faz sentido enquanto sobra
     fileira. No fim do rolamento ela apagaria a ultima pilula, entao
     aqui ela sai.
     --------------------------------------------------------------- */
  (function () {
    var ct = root.querySelector('.sth-ct');
    if (!ct) return;
    function marca() {
      var fim = ct.scrollLeft + ct.clientWidth >= ct.scrollWidth - 2;
      ct.classList.toggle('is-fim', fim);
    }
    ct.addEventListener('scroll', marca, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(marca).observe(ct);
    marca();
  })();

  var here = window.location.pathname.replace(/\/$/, '');
  root.querySelectorAll('.sth-nav__link').forEach(function (a) {
    try {
      if (new URL(a.href, window.location.origin).pathname.replace(/\/$/, '') === here && here !== '') {
        a.setAttribute('aria-current', 'page');
      }
    } catch (err) {}
  });
})();

/* ===================== CIRCLE · copiar o codigo =====================
   O retorno e a propria palavra virando "Copiado" por 2s. Um toast, num
   painel estreito, cobriria justamente o conteudo que a pessoa acabou de
   abrir pra ver. Delegado no document porque o menu e montado/remontado. */
document.addEventListener('click', function (ev) {
  var alvo = ev.target;
  var btn = (alvo && alvo.closest) ? alvo.closest('[data-circle-copiar]') : null;
  if (!btn) return;

  var cod = btn.getAttribute('data-codigo') || '';
  if (!cod) return;
  var rot = btn.querySelector('[data-circle-rotulo]');
  var antes = rot ? rot.textContent : '';

  function feito() {
    if (!rot) return;
    rot.textContent = 'Copiado';
    btn.classList.add('is-ok');
    clearTimeout(btn._circleT);
    btn._circleT = setTimeout(function () {
      rot.textContent = antes;
      btn.classList.remove('is-ok');
    }, 2000);
  }

  function reserva() {
    var t = document.createElement('textarea');
    t.value = cod;
    t.setAttribute('readonly', '');
    t.style.position = 'fixed';
    t.style.top = '-1000px';
    t.style.opacity = '0';
    document.body.appendChild(t);
    t.select();
    try { document.execCommand('copy'); feito(); } catch (e) { /* sem clipboard: a pessoa le e digita */ }
    document.body.removeChild(t);
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(cod).then(feito, reserva);
  } else {
    reserva();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellar-bento"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRotator(scope) {
    (scope || document).querySelectorAll('[data-stb-rotator]').forEach(function (box) {
      if (box.dataset.stbReady === '1') return;
      box.dataset.stbReady = '1';

      var steps = box.querySelectorAll('[data-stb-step]');
      var dots = box.querySelectorAll('[data-stb-dot]');
      if (steps.length < 2) return;

      var i = 0;
      var timer = null;
      var wait = (parseFloat(box.dataset.interval) || 5) * 1000;

      function show(n) {
        i = (n + steps.length) % steps.length;
        steps.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
        dots.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
      }
      function play() { stop(); timer = setInterval(function () { show(i + 1); }, wait); }
      function stop() { if (timer) clearInterval(timer); timer = null; }

      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { show(k); play(); });
      });
      box.addEventListener('mouseenter', stop);
      box.addEventListener('mouseleave', play);

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      play();
    });
  }

  function initPills(scope) {
    (scope || document).querySelectorAll('[data-stb-big]').forEach(function (big) {
      if (big.dataset.stbPills === '1') return;
      big.dataset.stbPills = '1';

      var row = big.querySelector('[data-stb-pills]');
      var pills = Array.prototype.slice.call(big.querySelectorAll('[data-stb-pill]'));
      if (!row || !pills.length) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function shrink(el) {
        if (!el.classList.contains('is-open')) return;
        var w0 = parseFloat(el.dataset.w0);
        el.style.width = el.offsetWidth + 'px';
        void el.offsetWidth;
        el.classList.add('is-closing');
        el.classList.remove('is-open');
        el.setAttribute('aria-expanded', 'false');
        el.style.width = w0 ? w0 + 'px' : '';
        window.setTimeout(function () { el.classList.remove('is-closing'); }, 380);
      }

      function grow(el) {
        if (!el.dataset.w0) el.dataset.w0 = el.offsetWidth;
        el.style.width = el.dataset.w0 + 'px';
        void el.offsetWidth;
        el.classList.add('is-open');
        el.setAttribute('aria-expanded', 'true');
        el.style.width = row.clientWidth + 'px';
      }

      function slide(mutate) {
        if (reduce) { mutate(); return; }
        var before = pills.map(function (p) { return p.getBoundingClientRect().top; });
        mutate();
        pills.forEach(function (p, i) {
          if (p.classList.contains('is-open') || p.classList.contains('is-closing')) return;
          var delta = before[i] - p.getBoundingClientRect().top;
          if (!delta) return;
          p.style.transition = 'none';
          p.style.transform = 'translateY(' + delta + 'px)';
          window.requestAnimationFrame(function () {
            p.style.transition = 'transform .52s cubic-bezier(.22,1,.36,1)';
            p.style.transform = '';
            window.setTimeout(function () {
              p.style.transition = '';
              p.style.transform = '';
            }, 560);
          });
        });
      }

      function closeAll() {
        slide(function () { pills.forEach(function (b) { shrink(b); }); });
      }

      function open(idx) {
        var target = null;
        pills.forEach(function (b) { if (b.dataset.i === idx) target = b; });
        if (!target) return;
        if (target.classList.contains('is-open')) {
          slide(function () { shrink(target); });
          return;
        }
        slide(function () {
          pills.forEach(function (b) { if (b !== target) shrink(b); });
          grow(target);
        });
      }

      big.stbOpen = open;
      big.stbClose = closeAll;

      pills.forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.stopPropagation();
          big.dataset.stbTouched = '1';
          open(b.dataset.i);
        });
      });

      document.addEventListener('click', function (e) {
        if (!big.contains(e.target)) closeAll();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAll();
      });
      window.addEventListener('resize', function () {
        pills.forEach(function (b) {
          if (b.classList.contains('is-open')) b.style.width = row.clientWidth + 'px';
        });
      }, { passive: true });
    });
  }

  function initExpand(scope) {
    (scope || document).querySelectorAll('[data-stb-runway]').forEach(function (runway) {
      if (runway.dataset.stbExp === '1') return;
      runway.dataset.stbExp = '1';

      var big = runway.querySelector('[data-stb-big]');
      var sticky = runway.querySelector('.stb__sticky');
      if (!big || !sticky) return;

      var ticking = false;
      var opened = false;
      var mq = window.matchMedia('(max-width: 900px)');
      var prestart = parseFloat(runway.dataset.prestart);
      var finish = parseFloat(runway.dataset.finish);
      var autoOpen = big.dataset.autoopen === '1';
      if (isNaN(prestart)) prestart = 45;
      if (isNaN(finish) || finish <= 0) finish = 50;

      function apply(v) {
        big.style.setProperty('--p', v);
        sticky.style.setProperty('--p', v);
      }

      function update() {
        ticking = false;
        if (!mq.matches) {
          big.style.removeProperty('--p');
          sticky.style.removeProperty('--p');
          return;
        }

        var rect = runway.getBoundingClientRect();
        var travel = rect.height - sticky.offsetHeight;
        if (travel < 0) travel = 0;

        var pre = window.innerHeight * (prestart / 100);
        var range = pre + travel * (finish / 100);
        if (range <= 0) range = 1;

        var p = (pre - rect.top) / range;
        p = p < 0 ? 0 : (p > 1 ? 1 : p);
        apply(p.toFixed(4));

        if (!autoOpen || !big.stbOpen) return;

        if (p > 0.985 && !opened) {
          opened = true;
          if (big.dataset.stbTouched !== '1') {
            window.setTimeout(function () {
              if (big.dataset.stbTouched !== '1') big.stbOpen('0');
            }, 320);
          }
        }
        if (p < 0.5 && opened) {
          opened = false;
          if (big.dataset.stbTouched !== '1' && big.stbClose) big.stbClose();
        }
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  }

  function init(scope) { initRotator(scope); initPills(scope); initExpand(scope); }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellar-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-shr]').forEach(function (root) {
      if (root.dataset.shrReady === '1') return;
      root.dataset.shrReady = '1';

      /* 25/09: as fotos dos outros slides entram depois do `load`, ou no
         primeiro toque. Video entra com `muted` pelo JS para poder tocar. */
      /* G4-12: com "reduzir movimento" nenhum video do topo anda sozinho —
         fica o primeiro quadro, e o botao de pausa nasce em "Retomar". */
      var REDUZ = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      if (REDUZ) root.querySelectorAll('video').forEach(function (v) { v.removeAttribute('autoplay'); if (v.pause) v.pause(); });
      function acordar() {
        root.querySelectorAll('template[data-shr-late]').forEach(function (t) {
          var slide = t.parentNode;
          slide.appendChild(t.content.cloneNode(true));
          t.parentNode.removeChild(t);
          slide.querySelectorAll('video').forEach(function (v) {
            v.muted = true;
            if (REDUZ || parado) { v.removeAttribute('autoplay'); if (v.pause) v.pause(); return; }
            var p = v.play && v.play();
            if (p && p.catch) p.catch(function () {});
          });
        });
      }
      if (window.Shopify && Shopify.designMode) {
        acordar();
      } else if (document.readyState === 'complete') {
        setTimeout(acordar, 200);
      } else {
        window.addEventListener('load', function () { setTimeout(acordar, 200); }, { once: true });
      }

      var slides = root.querySelectorAll('[data-shr-slide]');
      var slots = root.querySelectorAll('[data-shr-slot]');
      var dots = root.querySelectorAll('[data-shr-dot]');
      if (slides.length < 2) return;

      var i = 0;
      var timer = null;
      var wait = (parseFloat(root.dataset.interval) || 6) * 1000;

      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
        slots.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
        dots.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
      }
      /* `shr--anda` e o que liga a barrinha de progresso do ponto ativo.
         Fica no JS e nao no CSS porque so o JS sabe se o relogio esta
         correndo — parado, a barra tem de aparecer cheia, nao vazia. */
      function play() { stop(); root.classList.add('shr--anda'); timer = setInterval(function () { show(i + 1); }, wait); }
      function stop() { if (timer) clearInterval(timer); timer = null; root.classList.remove('shr--anda'); }

      /* G4-12 · PAUSA. Parado de verdade: sem troca de slide e sem video
         andando. `parado` e decisao da pessoa (ou do "reduzir movimento") e
         vale ate ela tocar em Retomar. */
      var pausa = root.querySelector('[data-shr-pausa]');
      var parado = false;
      function videos(tocar) {
        root.querySelectorAll('video').forEach(function (v) {
          if (tocar) { v.muted = true; var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
          else if (v.pause) v.pause();
        });
      }
      function parar(sim) {
        parado = sim;
        root.classList.toggle('shr--parado', sim);
        if (pausa) pausa.setAttribute('aria-label', sim ? 'Retomar apresentação' : 'Pausar apresentação');
        videos(!sim);
        if (sim) stop(); else { assumiu = false; play(); }
      }
      if (pausa) pausa.addEventListener('click', function (e) { e.stopPropagation(); parar(!parado); });
      /* foco de teclado dentro do topo segura a troca; ao sair, volta */
      root.addEventListener('focusin', function () { stop(); });
      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget) && !parado && !assumiu) play();
      });

      /* O PRIMEIRO TOQUE DESLIGA O AUTOPLAY DE VEZ.

         Nao e pausa: e entrega de controle. Quem tocou esta lendo aquele
         banner, e um relogio que volta a correr depois de alguns segundos
         puxa a leitura embaixo do dedo da pessoa. Uma vez que ela assumiu,
         o carrossel so anda quando ela mandar. */
      var assumiu = false;
      function assumir() { if (assumiu) return; assumiu = true; stop(); }

      /* O SLIDE ANDA COM O DEDO.

         A primeira versao disto ouvia `pointerup` e so trocava no fim do
         gesto. No celular ela nunca rodava: medido, o que chega e
         `pointercancel` — o navegador entende o arrasto como rolagem e toma
         o ponteiro antes do fim. Por isso duas mudancas aqui: o `pan-y` no
         CSS, que devolve o eixo horizontal para nos sem tirar o vertical da
         pagina, e `touchmove`/`touchend`, que nao sao cancelados.

         Enquanto o dedo anda, a foto de destino sobe de opacidade na mesma
         proporcao do deslocamento e os dois textos deslizam juntos. Se o
         dedo voltar, tudo volta — o gesto e reversivel ate o fim, que e o
         que separa "arrastar" de "dar um tapa na tela". */
      var x0 = null, y0 = null, eixo = null, arrastando = false, alvo = null;

      function vizinho(dx) { return (i + (dx < 0 ? 1 : -1) + slides.length) % slides.length; }

      function seguir(dx) {
        var L = root.clientWidth || 1;
        var f = Math.min(1, Math.abs(dx) / L);
        alvo = vizinho(dx);
        if (alvo === i) return;
        slides[i].style.opacity = String(1 - f);
        slides[alvo].style.opacity = String(f);
        slots[i].style.transform = 'translate3d(' + dx + 'px,0,0)';
        slots[i].style.opacity = String(1 - f);
        slots[alvo].style.visibility = 'visible';
        slots[alvo].style.opacity = String(f);
        slots[alvo].style.transform = 'translate3d(' + (dx + (dx < 0 ? L : -L)) + 'px,0,0)';
      }

      /* Devolver o controle para as classes: enquanto houver estilo inline,
         o `is-on` nao manda em nada. */
      function limpar() {
        [].forEach.call(slides, function (el) { el.style.opacity = ''; });
        [].forEach.call(slots, function (el) {
          el.style.opacity = ''; el.style.transform = ''; el.style.visibility = '';
        });
      }

      function comecar(t) { acordar(); x0 = t.clientX; y0 = t.clientY; eixo = null; arrastando = false; assumir(); }
      function mover(t) {
        if (x0 === null) return;
        var dx = t.clientX - x0, dy = t.clientY - y0;
        /* o eixo se decide UMA vez, nos primeiros pixels: sem isso um gesto
           quase vertical faria a foto piscar de leve o tempo todo */
        if (eixo === null) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          eixo = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (eixo === 'x') { arrastando = true; root.classList.add('shr--arrastando'); }
        }
        if (eixo !== 'x') return;
        seguir(dx);
      }
      function terminar(t) {
        if (x0 === null) return;
        var dx = (t ? t.clientX : x0) - x0;
        x0 = null;
        root.classList.remove('shr--arrastando');
        if (!arrastando) return;
        arrastando = false;
        var L = root.clientWidth || 1;
        var passou = Math.abs(dx) > Math.min(70, L * 0.18);
        var destino = passou ? vizinho(dx) : i;
        limpar();
        show(destino);
      }

      root.addEventListener('pointerdown', function (e) { comecar(e); }, { passive: true });
      root.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse' && !e.buttons) return; mover(e); }, { passive: true });
      root.addEventListener('pointerup', function (e) { terminar(e); }, { passive: true });
      /* o cancelamento e o caso comum no toque, nao a excecao */
      root.addEventListener('pointercancel', function () { terminar(null); }, { passive: true });
      root.addEventListener('touchmove', function (e) { mover(e.touches[0]); }, { passive: true });
      root.addEventListener('touchend', function (e) { terminar(e.changedTouches[0]); }, { passive: true });
      root.addEventListener('touchcancel', function () { terminar(null); }, { passive: true });

      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { acordar(); assumir(); show(k); });
      });

      if (REDUZ) { parar(true); return; }
      play();
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellar-popup-circle"] && !Shopify.designMode) return;
  try {
    
/* Abre o popup por ancora. Delegado no document porque o hero e montado
   e remontado pelo carrossel — listener preso no link morre junto com ele. */
(function () {
  function achar(anc) {
    var todos = document.querySelectorAll('dialog[data-ppc-ancora]');
    for (var i = 0; i < todos.length; i++) {
      if (todos[i].getAttribute('data-ppc-ancora') === anc) return todos[i];
    }
    return null;
  }

  document.addEventListener('click', function (ev) {
    var alvo = ev.target;
    if (!alvo || !alvo.closest) return;

    var fechar = alvo.closest('[data-ppc-fechar]');
    if (fechar) {
      var d = fechar.closest('dialog');
      if (d) { ev.preventDefault(); d.close(); }
      return;
    }

    var link = alvo.closest('a[href^="#"]');
    if (!link) return;
    var anc = (link.getAttribute('href') || '').slice(1);
    if (!anc) return;

    var dlg = achar(anc);
    /* Sem <dialog> no navegador, o link nao vira nada: melhor do que rolar
       a pagina ate o topo e a pessoa achar que quebrou. */
    if (!dlg || typeof dlg.showModal !== 'function') return;

    ev.preventDefault();
    if (!dlg.open) dlg.showModal();
  });

  /* Clique no fundo escuro fecha. O <dialog> conta o backdrop como ele
     mesmo, entao so fecha quando o alvo e o proprio dialog. */
  document.addEventListener('click', function (ev) {
    if (ev.target && ev.target.tagName === 'DIALOG' && ev.target.open) {
      ev.target.close();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellar-produtos-b"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-sap]').forEach(function (root) {
      if (root.dataset.sapReady === '1') return;
      root.dataset.sapReady = '1';

      var scroller = root.querySelector('[data-sap-scroll]');
      var bar = root.querySelector('[data-sap-bar]');
      var prev = root.querySelector('[data-sap-prev]');
      var next = root.querySelector('[data-sap-next]');
      var tabs = root.querySelectorAll('[data-sap-tabs] button');
      var items = root.querySelectorAll('[data-sap-item]');
      var eyebrow = root.querySelector('[data-sap-eyebrow]');
      var title = root.querySelector('[data-sap-title]');

      function step() {
        var card = scroller.querySelector('.sap__card:not([hidden])');
        return card ? card.getBoundingClientRect().width + 16 : 280;
      }

      function progress() {
        if (!bar || !scroller) return;
        var max = scroller.scrollWidth - scroller.clientWidth;
        var visible = scroller.clientWidth / Math.max(scroller.scrollWidth, 1);
        var pct = max > 0 ? (scroller.scrollLeft / max) : 0;
        var w = Math.max(visible * 100, 12);
        bar.style.width = w + '%';
        bar.style.transform = 'translateX(' + (pct * (100 / (w / 100) - 100)) + '%)';
        if (prev) prev.disabled = scroller.scrollLeft <= 2;
        if (next) next.disabled = scroller.scrollLeft >= max - 2;
      }

      if (prev) prev.addEventListener('click', function () { scroller.scrollLeft -= step(); });
      if (next) next.addEventListener('click', function () { scroller.scrollLeft += step(); });
      if (scroller) scroller.addEventListener('scroll', progress, { passive: true });
      window.addEventListener('resize', progress, { passive: true });

      function setMode(mode) {
        root.dataset.mode = mode;
        tabs.forEach(function (t) { t.classList.toggle('is-on', t.dataset.mode === mode); });
        items.forEach(function (el) {
          var aud = el.dataset.aud || 'both';
          el.hidden = !(aud === 'both' || aud === mode);
        });
        if (eyebrow && eyebrow.dataset[mode]) eyebrow.textContent = eyebrow.dataset[mode];
        if (title && title.dataset[mode]) title.textContent = title.dataset[mode];
        if (scroller) scroller.scrollLeft = 0;
        window.requestAnimationFrame(progress);
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { setMode(t.dataset.mode); });
      });

      setMode(root.dataset.mode || 'me');
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellar-produtos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-stp]').forEach(function (root) {
      if (root.dataset.stpReady === '1') return;
      root.dataset.stpReady = '1';

      var scroller = root.querySelector('[data-stp-scroll]');
      var bar = root.querySelector('[data-stp-bar]');
      var prev = root.querySelector('[data-stp-prev]');
      var next = root.querySelector('[data-stp-next]');
      var tabs = root.querySelectorAll('[data-stp-tabs] button');
      var items = root.querySelectorAll('[data-stp-item]');
      var eyebrow = root.querySelector('[data-stp-eyebrow]');
      var title = root.querySelector('[data-stp-title]');

      function step() {
        var card = scroller.querySelector('.stp__card:not([hidden])');
        return card ? card.getBoundingClientRect().width + 16 : 260;
      }

      function progress() {
        if (!bar || !scroller) return;
        var max = scroller.scrollWidth - scroller.clientWidth;
        var visible = scroller.clientWidth / Math.max(scroller.scrollWidth, 1);
        var pct = max > 0 ? (scroller.scrollLeft / max) : 0;
        var w = Math.max(visible * 100, 12);
        bar.style.width = w + '%';
        bar.style.transform = 'translateX(' + (pct * (100 / (w / 100) - 100)) + '%)';
        if (prev) prev.disabled = scroller.scrollLeft <= 2;
        if (next) next.disabled = scroller.scrollLeft >= max - 2;
      }

      if (prev) prev.addEventListener('click', function () { scroller.scrollLeft -= step(); });
      if (next) next.addEventListener('click', function () { scroller.scrollLeft += step(); });
      if (scroller) scroller.addEventListener('scroll', progress, { passive: true });
      window.addEventListener('resize', progress, { passive: true });

      function setMode(mode) {
        root.dataset.mode = mode;
        tabs.forEach(function (t) { t.classList.toggle('is-on', t.dataset.mode === mode); });
        items.forEach(function (el) {
          var aud = el.dataset.aud || 'both';
          el.hidden = !(aud === 'both' || aud === mode);
        });
        if (eyebrow && eyebrow.dataset[mode]) eyebrow.textContent = eyebrow.dataset[mode];
        if (title && title.dataset[mode]) title.textContent = title.dataset[mode];
        if (scroller) scroller.scrollLeft = 0;
        window.requestAnimationFrame(progress);
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { setMode(t.dataset.mode); });
      });

      setMode(root.dataset.mode || 'me');
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
